var React = require('react');

function Tg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.1529 20.6488L22.3946 4.73749C22.5972 4.21409 22.4959 3.69068 22.192 3.27196C21.8881 2.95792 21.3815 2.95793 21.0776 3.06261L1.82958 10.7042C1.52567 10.8089 1.22179 11.0183 0.917872 11.2276C0.715261 11.437 0.715224 11.6463 0.816529 11.8557C1.01914 12.0651 1.22176 12.2744 1.52568 12.2744L6.48967 13.8446L17.9372 6.41235C18.2411 6.20299 18.4437 6.203 18.6463 6.30768C18.7476 6.41236 18.7476 6.51703 18.545 6.62171L9.32621 15.2055L8.92097 20.4394C9.32619 20.4394 9.6301 20.2301 9.93402 19.916L12.3654 17.5084L17.3293 21.2769C18.3424 22.1143 18.8489 21.8003 19.1529 20.6488Z","fill":"rgba(255, 255, 255, 0.72)"}));
}

Tg.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Tg;

Tg.default = Tg;
